import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Loader = ({ message }) => {
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0,
      width: '100%', height: '100%',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      backgroundColor: 'rgba(173, 173, 173, 0.7)', zIndex: 5000
    }}>
      <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: '#0C53BB' }} spin />} />
      <span style={{
        position: 'absolute', top: '56%', left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '14px', color: '#5A6C87'
      }}>
        {message || "Fetching Data..." }
      </span>
    </div>
  );
};

Loader.propTypes = {
  message: PropTypes.string
};


export default Loader;
